import { Form, Select, message } from 'antd';
import { NamePath } from 'antd/lib/form/interface';

const isNotValidUrl = (urlString: string): boolean => {
  const urlWithProtocol = urlString.includes('://')
    ? urlString
    : `http://${urlString}`;

  const url = new URL(urlWithProtocol);
  const hostPart = url.host.split('.');
  return !(hostPart.length >= 2 && hostPart.every((part) => part.length > 0));
};

type URLSelectorProps = {
  name?: NamePath;
  label?: string;
  placeholder?: string;
};

export const URLSelectorFormItem = ({
  name,
  label,
  placeholder = 'Add a URL',
}: URLSelectorProps) => {
  return (
    <Form.Item label={label} name={name}
    rules={[
      {
        validator: async (_, value) => {
          if (value && value.length > 0) {
            const invalidUrls = value.filter(isNotValidUrl);
            if (invalidUrls.length > 0) {
              message.error(
                `The following URLs are invalid: ${invalidUrls.join(', ')}`
              );
              return Promise.reject();
            }
          }
          return Promise.resolve();
        },
      },
    ]}>
      <Select
        mode="tags"
        className="min-w-200px"
        placeholder={placeholder}
        tokenSeparators={[',']}
      />
    </Form.Item>
  );
};
